module.exports = __webpack_public_path__ + "img/product_item_bg2.2f26ce47.png";